import React from 'react';
import { FlatButton } from 'material-ui';
import WidgetList from '../../editor/components/WidgetList';
import { compose, branch, renderComponent, renderNothing } from 'recompose';

import { withTeamWidgets } from '../hoc/widgets';

const NoWidgets = () => <div style={{ textAlign: 'center', padding: 15 }}>Please select team above</div>;
const NoTWidgets = () => <div style={{ textAlign: 'center', padding: 15 }}>Please select tournamnet above</div>;

const TeamOverview = compose(
    branch(({ tournamentId }) => !tournamentId, renderComponent(NoTWidgets)),
    branch(({ teamId }) => !teamId, renderComponent(NoWidgets)),
)(withTeamWidgets(WidgetList));

export default TeamOverview;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/TeamOverview.js
 **/